import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './apps/store/store'
import InlineSearch from "./apps/inline-search/InlineSearch.jsx"

// Import React Apps
import './apps/product/index.jsx'
import './apps/product-tiles/index.jsx'
import './apps/cart-drawer/index.jsx'
import './apps/address-form/index.jsx'
// import './apps/full-search/index.jsx'

// Components
import { setupNewsletters } from './components/Newsletter.js'
import { setupPaginations } from './components/Pagination.js'
import { setupCountrySelector } from './components/CountrySelector.js'
import { setupInlineProductAddButtons } from './components/InlineProductAdd.js'
import { setupPopup } from './components/Popup.js'

// Sections
import { setupHeader } from './sections/header.js'
import { setupHero } from './sections/hero.js'
import { setupCollection } from './sections/collection.js'
import { setupProduct } from './sections/product.js'
import { setupRelatedProducts } from './sections/related-products.js'
import { setupTabProducts } from './sections/tab-products.js'
import { setupCart } from './sections/cart.js'
import { setupFlagshipHero } from './sections/flagship-hero.js'
import { setupHistory } from './sections/history.js'
import { setupAccount } from './sections/account.js'
import { setupShopByColor } from './sections/shop-by-color.js'
import { setupOffersGrid } from './sections/offers-grid.js'
import { setupStyleAssets } from './sections/style-assets.js'
import { setupCategorySlider } from './sections/category-slider.js'
import { setupImageWithText } from './sections/image-with-text.js'
import { setupThreeUps } from './sections/three-up.js'
import { setupFooter } from './sections/footer.js'
import { setupFAQ } from './sections/faq.js' 

// Utils
import { adjustADA } from './utils/helpers.js'

document.addEventListener('DOMContentLoaded', () => {
  // Sections
  setupHeader()
  setupHero()
  setupCollection()
  setupProduct()
  setupRelatedProducts()
  setupTabProducts()
  setupCart()
  setupFlagshipHero()
  setupHistory()
  setupAccount()
  setupShopByColor()
  setupOffersGrid()
  setupStyleAssets()
  setupCategorySlider()
  setupImageWithText()
  setupThreeUps()
  setupFooter()
  setupFAQ()

  // Components
  setupNewsletters()
  setupPaginations()
  setupCountrySelector()
  setupInlineProductAddButtons()
  setupPopup()


  // Init Search Components after setupHeader
  const searchWrappers = document.querySelectorAll('[data-search-form]')
  searchWrappers.forEach((searchWrapper) => {
    const root = createRoot(searchWrapper)
    root.render(
      <Provider store={store}>
        <InlineSearch />
      </Provider>)
  })
  setTimeout(() => {
    if (typeof window._swat != 'undefined' && window._swat.initializeActionButtons) _swat.initializeActionButtons('.product-grid', '[data-swaction]')
  }, 1500)

  // Utils
  adjustADA()
  window.updateSearchRecommend()
})